import { useEffect, useState } from "react";
import { Order, OrderItem } from "@/types/order";
import storage from "@/utils/storage";
import { getAuthenticatedPages } from "@/utils/helpers";
import { OrderItemWithCurrency } from "./items-table/hooks";

export type TableView = "orders" | "items";

export type TableStates = {
  view: TableView;
  setView: React.Dispatch<React.SetStateAction<TableView>>;
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedOrder: Order | OrderItemWithCurrency | undefined;
  setSelectedOrder: React.Dispatch<
    React.SetStateAction<Order | OrderItem | undefined>
  >;
};

const useOrders = () => {
  const [view, setView] = useState<TableView>("orders");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<
    Order | OrderItemWithCurrency | undefined
  >(undefined);

  const isBrandPage = getAuthenticatedPages().brand;

  useEffect(() => {
    const storedView = isBrandPage
      ? storage.getItem("brand_orders_table_view")
      : storage.getItem("orders_table_view");

    if (storedView) {
      setView(storedView as TableView);
    } else {
      setView("orders");
    }
  }, []);

  return {
    view,
    setView,
    sidebarOpen,
    setSidebarOpen,
    selectedOrder,
    setSelectedOrder,
  } as TableStates;
};

export { useOrders };
